import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../../services/LessonComponentService';
import { ListComponent } from '../../../models/LessonComponent';
import { ListNumber } from './ListNumber';
import React from 'react';
import { SelectionOption } from '../../../models/LessonComponentContent';
import styles from '../../../styles/List.module.scss';
import useThemes from '../../../../shared/hooks/useThemes';

interface ListProps {
  component: ListComponent;
}
export const ListComponentView = (props: ListProps) => {
  const items: SelectionOption[] = props.component.content?.options || [];
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;
  const paragraphStyle = muiTheme.typography.custom1;

  return (
    <Grid>
      {items
        ?.filter((item) => item.label)
        .map((item, index) => (
          <Grid
            key={item.value}
            container
            alignItems="center"
            className={styles.itemSpacing}
            style={{ fontFamily }}
          >
            <ListNumber
              component={props.component}
              sequenceNumber={
                props.component.settings.listSettings?.startNumber + index
              }
            />
            <Grid className={styles.itemLabel} style={paragraphStyle}>
              <span
                className="ql-editor"
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(item.label)
                }}
              ></span>
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
};
